import { getBaseURL } from '@/lib/api-base-url';

export async function fetchJSON<T>(url: string): Promise<T> {
  const baseURL = getBaseURL();
  const fullUrl = url.startsWith('http') ? url : `${baseURL}${url.startsWith('/') ? url : `/${url}`}`;
  
  const res = await fetch(fullUrl, {
    credentials: 'include',
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch ${fullUrl}: ${res.status} ${res.statusText}`);
  }

  return res.json();
}
